module.exports = __webpack_public_path__ + "static/media/walkthrough-funnel-creation.e9617eb7.png";